export default {"src":"/_next/static/image/public/images/referral_gift_banner_coupon.6ce20d59da2871d31cac14f48649c525.svg","height":132,"width":173};